import type { MutationTree } from 'vuex';
import type { Answer } from '@@/packages/shared/types/models/answer';
import type { ScopingAnswer } from '@@/packages/shared/types/models/scopingAnswer';
import type { AssessmentStatus } from '@@/packages/shared/types/models/assessmentStatus';
import type { ReassessmentStatus } from '@@/packages/shared/types/models/reassessment';

const initialState = () => ({
  controlAnswers: {} as Record<string, Answer>,
  scopingAnswers: {} as Record<string, ScopingAnswer>,
  status: {} as AssessmentStatus,
  reassessmentStatus: {} as ReassessmentStatus,
});

export const defaultState = initialState();
export type AssessmentState = typeof defaultState;

export const mutations: MutationTree<AssessmentState> = {
  SET_ASSESSMENT_STATUS(state, data: AssessmentState['status']) {
    // Round assessment status percentage down to an integer.
    data.assessmentProgress = Math.floor(data.assessmentProgress);
    state.status = data;
  },
  SET_SCOPING_ANSWERS(state, data: AssessmentState['scopingAnswers']) {
    state.scopingAnswers = data;
  },
  SET_CONTROL_ANSWERS(state, data: AssessmentState['controlAnswers']) {
    state.controlAnswers = data;
  },
  CLEAR_STATE(state) {
    Object.assign(state, initialState());
  },
};
